import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PillsModule } from '@nibtravel/shared/ui/components/pills';
import { IdOrDefaultModule } from '@nibtravel/shared/ui/directives/id-or-default';
import { InputModule } from '@nibtravel/shared/ui/forms/input';
import { ValidationModule } from '@nibtravel/shared/ui/forms/validation';

import { AutocompleteHandlerComponent } from './autocomplete-handler.component';
import { AutocompleteOptionComponent } from './autocomplete-option.component';
import { AutocompleteComponent } from './autocomplete.component';
import { AutocompleteDirective } from './autocomplete.directive';

@NgModule({
  declarations: [
    AutocompleteHandlerComponent,
    AutocompleteOptionComponent,
    AutocompleteDirective,
    AutocompleteComponent,
  ],
  exports: [AutocompleteComponent],
  imports: [
    CommonModule,
    OverlayModule,
    InputModule,
    PillsModule,
    ValidationModule,
    IdOrDefaultModule,
  ],
})
export class AutocompleteModule {}
